"use client";

import { sectionAnchorScrollMarginPx } from "@/lib/consts";
import {
  Container,
  Stack,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SLHtmlFromLangFile } from "../sections/home/SLHtmlFromLangFile";

function SLContainerStatic({
  id,
  title,
  subtitle,
  children,
  ref,
  hasPaddingTop,
  width,
  sx,
}: {
  id?: string;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement | null>;
  hasPaddingTop?: boolean;
  width?: "xl" | "lg" | "md" | "sm" | "xs";
  sx?: SxProps;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const verticalPadding = isMobile ? 5 : 10;

  return (
    <Container
      component="section"
      maxWidth={width}
      id={id}
      ref={ref}
      sx={{
        overflow: "clip",
        pb: verticalPadding,
        position: "relative",
        width: "100%",
        height: "fit-content",
        ...(id ? { scrollMarginTop: `${sectionAnchorScrollMarginPx}px` } : {}),
        ...sx,
      }}
    >
      <Stack
        direction="column"
        pt={hasPaddingTop ? verticalPadding : 0}
        sx={{ position: "relative", height: "fit-content" }}
      >
        <Stack sx={{ width: "100%" }}>
          <Stack>
            {title &&
              (typeof title === "string" ? (
                <Typography variant="h2" component="h2" mb={subtitle ? 3 : 5}>
                  <SLHtmlFromLangFile htmlString={title} />
                </Typography>
              ) : (
                title
              ))}
            {subtitle && typeof subtitle === "string" ? (
              <Typography
                variant="body1"
                fontSize={theme.typography.h6.fontSize}
                mb={title ? 10 : 0}
              >
                <SLHtmlFromLangFile htmlString={subtitle} />
              </Typography>
            ) : (
              subtitle
            )}
          </Stack>
        </Stack>
        <Stack
          sx={{ height: "fit-content", position: "relative", width: "100%" }}
        >
          {children}
        </Stack>
      </Stack>
    </Container>
  );
}

export { SLContainerStatic };
